import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		helperText: {
			color: "red",
			margin: 0
		},
		saveRow: {
			position: "sticky", 
			top: 64, 
			zIndex: 1000, 
			backgroundColor: theme.palette.background.default
		},
		formControl: {
			minWidth: 450
		},
		typeSelect: {
			width: 250
		}
	} satisfies Record<string, CSSObject>;
};